export enum InclusionCriterion {
  Patient = 'patient',
  Intervention = 'intervention',
  ComparisonControlComparator = 'comparisonControlComparator',
  Outcomes = 'outcomes',
  StudyDesign = 'studyDesign',
  Timing = 'timing',
}
